import React from "react";
import Layout from "../components/layout/layout.js";
const Contact = () => {
  return (
    <Layout>
      <h1>Contact</h1>
    </Layout>
  );
};

export default Contact;
